import { fromEntries } from './fromEntries';

export const omit = (obj: {}, keys: string[]) => {
  return fromEntries(
    Object.entries(obj).filter(([key]) => !keys.includes(key))
  );
};
